import { render } from "./TemplateDashboard.vue?vue&type=template&id=a0baa0aa"
import script from "./TemplateDashboard.vue?vue&type=script&lang=js"
export * from "./TemplateDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__